<template>
  <main class="grid-container pb-5">
    <!-- VIEW PAGE -->
    <div v-if="step === 'read'" id="tcrm-details-view">
      <div class="section-header section-header--xl section-header--dividing mt-3">
        <h1 class="heading">{{ bp('title') }}</h1>
        <div>
          <trek-button text icon="edit" @click="enableEditStep">
            <span v-html="bp('edit')"></span>
          </trek-button>
        </div>
      </div>

      <div class="max-w-md">
        <p class="mb-3">{{ bp('tcrmLegal1') }}</p>
        <p class="mb-3">{{ bp('tcrmLegal2') }}</p>
        <p class="mb-3">
          <span class="font-bold">{{ bp('tcrmLegal3') }}</span>
          {{ bp('tcrmLegal4') }}
        </p>
      </div>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('marketingContact') }}</h3>
      </div>

      <section class="mb-3">
        <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
          <tbody>
            <tr>
              <th scope="row">{{ bp('firstName') }}</th>
              <td>{{ tcrmData.tcrm.tcrmContactFirstName }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('surname') }}</th>
              <td>{{ tcrmData.tcrm.tcrmContactLastName }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('phone') }}</th>
              <td>{{ tcrmData.tcrm.tcrmContactPhone }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('email') }}</th>
              <td>{{ tcrmData.tcrm.tcrmContactEmail }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('marketingChannels') }}</h3>
      </div>

      <section class="mb-3">
        <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
          <tbody>
            <tr>
              <th scope="row">{{ bp('replyToAddress') }}</th>
              <td>{{ tcrmData.tcrm.tcrmReplyToEmail }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('facebookURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmFacebookUrl }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('googlePlusURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmGoogleUrl }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('twitterURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmTwitterUrl }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('campaignLandingURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmCampaignLandingUrl }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('emailPromotions') }}</h3>
      </div>

      <section class="mb-3">
        <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
          <tbody>
            <tr>
              <th scope="row">{{ bp('thankYouEmail') }}</th>
              <template v-for="(item, index) in tcrmData.tcrm.tcrmThankYouEmail">
                <td v-if="item.active" :key="index">{{ item.name }}</td>
              </template>
            </tr>
            <tr>
              <th scope="row">{{ bp('bikeBirthdayEmail') }}</th>
              <template v-for="(item, index) in tcrmData.tcrm.tcrmBikeBirthdayEmail">
                <td v-if="item.active" :key="index">{{ item.name }}</td>
              </template>
            </tr>
            <tr>
              <th scope="row">{{ bp('serviceReminderEmail') }}</th>
              <template v-for="(item, index) in tcrmData.tcrm.tcrmSixMonthServiceReminderEmail">
                <td v-if="item.active" :key="index">{{ item.name }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('catalogPromotions') }}</h3>
      </div>

      <section class="mb-3">
        <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
          <tbody>
            <tr>
              <th scope="row">{{ bp('catalogCoupons') }}</th>
              <template v-for="(item, index) in tcrmData.tcrm.tcrmCatalogCoupons">
                <td v-if="item.active" :key="index">{{ item.name }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('paidSearch') }}</h3>
      </div>

      <section class="mb-3">
        <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
          <tbody>
            <tr>
              <th scope="row">{{ bp('participatePaidSearch') }}</th>
              <template v-for="(item, index) in tcrmData.tcrm.tcrmPaidSearchParticipation">
                <td v-if="item.active" :key="index">{{ bp(item.name) }}</td>
              </template>
            </tr>
            <tr>
              <th scope="row">{{ bp('budget') }}</th>
              <td>{{ tcrmData.tcrm.tcrmPaidSearchBudget }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('zipCode') }}</th>
              <td>{{ tcrmPaidSearchZipCodes }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('findShopURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmPaidSearchFindLocalBikeShopUrl }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('serviceURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmPaidSearchServiceAndRepairUrl }}</td>
            </tr>
            <tr>
              <th scope="row">{{ bp('bikeFittingURL') }}</th>
              <td>{{ tcrmData.tcrm.tcrmPaidSearchBikeFittingUrl }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <!-- EDIT PAGE  -->
    <div v-else id="tcrm-details-edit">
      <div class="section-header section-header--xl section-header--dividing mt-3">
        <h1 class="heading">{{ bp('title') }}</h1>
      </div>

      <div class="max-w-md">
        <p class="mb-3">{{ bp('tcrmLegal1') }}</p>
        <p class="mb-3">{{ bp('tcrmLegal2') }}</p>
        <p class="mb-3">
          <span class="font-bold">{{ bp('tcrmLegal3') }}</span>
          {{ bp('tcrmLegal4') }}
        </p>
      </div>

      <div class="section-header section-header--md section-header--dividing mt-3">
        <h3 class="heading">{{ bp('marketingContact') }}</h3>
      </div>

      <form
        ref="TCRMDetailsForm"
        :action="editUrl"
        modelAttribute="tcrmData"
        method="POST"
        @submit.prevent="validateAndSubmit"
      >
        <section class="mb-3 max-w-sm">
          <input id="code" v-model="code" type="hidden" name="code" />

          <form-group
            id="tcrmContactFirstName"
            v-model="tcrmData.tcrm.tcrmContactFirstName"
            :data-vv-as="bp('firstName')"
            :label="bp('firstName')"
            :error="errors.first('tcrmContactFirstName')"
            :show-error-messages="true"
            type="text"
            name="tcrmContactFirstName"
            qaid="tcrm-edit-firstName"
          ></form-group>
          <form-group
            id="tcrmContactLastName"
            v-model="tcrmData.tcrm.tcrmContactLastName"
            :data-vv-as="bp('surname')"
            :label="bp('surname')"
            :error="errors.first('tcrmContactLastName')"
            :show-error-messages="true"
            type="text"
            name="tcrmContactLastName"
            qaid="tcrm-edit-lastName"
          ></form-group>

          <form-group
            id="tcrmContactEmail"
            v-model="tcrmData.tcrm.tcrmContactEmail"
            v-validate="'email'"
            :data-vv-as="bp('email')"
            :label="bp('email')"
            :error="errors.first('tcrmContactEmail')"
            :show-error-messages="true"
            type="email"
            name="tcrmContactEmail"
            qaid="tcrm-edit-email"
          ></form-group>

          <form-group
            id="tcrmContactPhone"
            v-model="tcrmData.tcrm.tcrmContactPhone"
            :data-vv-as="bp('phone')"
            :label="bp('phone')"
            :error="errors.first('tcrmContactPhone')"
            :show-error-messages="true"
            type="text"
            name="tcrmContactPhone"
            qaid="tcrm-edit-phone"
          ></form-group>
        </section>

        <div class="section-header section-header--md section-header--dividing mt-3">
          <h3 class="heading">{{ bp('marketingChannels') }}</h3>
        </div>

        <div class="max-w-sm">
          <section class="mb-3 max-w-sm">
            <form-group
              id="tcrmReplyToEmail"
              v-model="tcrmData.tcrm.tcrmReplyToEmail"
              v-validate="'email'"
              :data-vv-as="bp('replyToAddress')"
              :label="bp('replyToAddress')"
              :error="errors.first('tcrmReplyToEmail')"
              :show-error-messages="true"
              type="email"
              name="tcrmReplyToEmail"
              qaid="tcrm-edit-replyToEmail"
            ></form-group>

            <form-group
              id="tcrmFacebookUrl"
              v-model="tcrmData.tcrm.tcrmFacebookUrl"
              :data-vv-as="bp('facebookURL')"
              :label="bp('facebookURL')"
              :error="errors.first('tcrmFacebookUrl')"
              :show-error-messages="true"
              type="text"
              name="tcrmFacebookUrl"
              qaid="tcrm-edit-facebookUrl"
            ></form-group>

            <form-group
              id="tcrmGoogleUrl"
              v-model="tcrmData.tcrm.tcrmGoogleUrl"
              :data-vv-as="bp('googlePlusURL')"
              :label="bp('googlePlusURL')"
              :error="errors.first('tcrmGoogleUrl')"
              :show-error-messages="true"
              type="text"
              name="tcrmGoogleUrl"
              qaid="tcrm-edit-googleUrl"
            ></form-group>

            <form-group
              id="tcrmTwitterUrl"
              v-model="tcrmData.tcrm.tcrmTwitterUrl"
              :data-vv-as="bp('twitterURL')"
              :label="bp('twitterURL')"
              :error="errors.first('tcrmTwitterUrl')"
              :show-error-messages="true"
              type="text"
              name="tcrmTwitterUrl"
              qaid="tcrm-edit-twitterUrl"
            ></form-group>

            <form-group
              id="tcrmCampaignLandingUrl"
              v-model="tcrmData.tcrm.tcrmCampaignLandingUrl"
              :data-vv-as="bp('campaignLandingURL')"
              :label="bp('campaignLandingURL')"
              :error="errors.first('tcrmCampaignLandingUrl')"
              :show-error-messages="true"
              type="text"
              name="tcrmCampaignLandingUrl"
              qaid="tcrm-edit-campaignLandingUrl"
            ></form-group>
          </section>
        </div>

        <div class="section-header section-header--md section-header--dividing mt-3">
          <h3 class="heading">{{ bp('marketingChannels') }}</h3>
        </div>

        <div class="max-w-sm">
          <section class="mb-3">
            <legend class="form-fieldset__legend" v-html="bp('thankYouEmail')"></legend>
            <label v-for="(item, index) in tcrmData.tcrm.tcrmThankYouEmail" :id="item.code" :key="index" class="radio">
              <input
                :id="item.code"
                v-model="tcrmThankYouEmail"
                type="radio"
                name="tcrmThankYouEmailValue"
                :value="item.code"
              />
              <span class="control-indicator"></span>
              {{ item.name }}
            </label>
          </section>

          <section class="mb-3">
            <legend class="form-fieldset__legend" v-html="bp('bikeBirthdayEmail')"></legend>
            <label
              v-for="(item, index) in tcrmData.tcrm.tcrmBikeBirthdayEmail"
              :id="item.code"
              :key="index"
              class="radio"
            >
              <input
                :id="item.code"
                v-model="tcrmBikeBirthdayEmail"
                type="radio"
                name="tcrmBikeBirthdayEmailValue"
                :value="item.code"
              />
              <span class="control-indicator"></span>
              {{ item.name }}
            </label>
          </section>

          <section class="mb-3">
            <legend class="form-fieldset__legend" v-html="bp('serviceReminderEmail')"></legend>
            <label
              v-for="(item, index) in tcrmData.tcrm.tcrmSixMonthServiceReminderEmail"
              :id="item.code"
              :key="index"
              class="radio"
            >
              <input
                :id="item.code"
                v-model="tcrmSixMonthServiceReminderEmail"
                type="radio"
                name="tcrmSixMonthServiceReminderEmailValue"
                :value="item.code"
              />
              <span class="control-indicator"></span>
              {{ item.name }}
            </label>
          </section>
        </div>

        <div class="section-header section-header--md section-header--dividing mt-3">
          <h3 class="heading">{{ bp('catalogPromotions') }}</h3>
        </div>

        <section class="mb-3">
          <legend class="form-fieldset__legend" v-html="bp('catalogPromotions')"></legend>
          <label v-for="(item, index) in tcrmData.tcrm.tcrmCatalogCoupons" :id="item.code" :key="index" class="radio">
            <input
              :id="item.code"
              v-model="tcrmCatalogCoupons"
              type="radio"
              name="tcrmCatalogCouponsValue"
              :value="item.code"
            />
            <span class="control-indicator"></span>
            {{ item.name }}
          </label>
        </section>

        <div class="section-header section-header--md section-header--dividing mt-3">
          <h3 class="heading">{{ bp('paidSearch') }}</h3>
        </div>

        <div class="max-w-sm">
          <section class="mb-3">
            <legend class="form-fieldset__legend" v-html="bp('participatePaidSearch')"></legend>
            <label
              v-for="(item, index) in tcrmData.tcrm.tcrmPaidSearchParticipation"
              :id="item.code"
              :key="index"
              class="radio"
            >
              <input
                :id="item.code"
                v-model="tcrmPaidSearchParticipation"
                type="radio"
                name="tcrmPaidSearchParticipationValue"
                :value="item.code"
                @change="searchParticipationDialog"
              />
              <span class="control-indicator"></span>
              {{ bp(`${item.name}`) }}
            </label>
          </section>

          <form-group
            id="tcrmPaidSearchBudget"
            v-model="tcrmPaidSearchBudget"
            v-validate="NoPaidParticipate ? '' : 'required'"
            :disabled="NoPaidParticipate"
            :data-vv-as="bp('budget')"
            :label="bp('budget')"
            :error="errors.first('tcrmPaidSearchBudget')"
            :show-error-messages="true"
            type="text"
            name="tcrmPaidSearchBudget"
            qaid="tcrm-edit-budget"
          ></form-group>

          <form-group
            id="tcrmPaidSearchZipCodes"
            v-model="tcrmPaidSearchZipCodes"
            v-validate="NoPaidParticipate ? '' : 'required'"
            :disabled="NoPaidParticipate"
            :data-vv-as="bp('zipCode')"
            :label="bp('zipCode')"
            :error="errors.first('tcrmPaidSearchZipCodes')"
            :show-error-messages="true"
            type="textarea"
            name="tcrmPaidSearchZipCodes"
            qaid="tcrm-edit-zipCode"
          ></form-group>

          <form-group
            id="tcrmPaidSearchFindLocalBikeShopUrl"
            v-model="tcrmPaidSearchFindLocalBikeShopUrl"
            v-validate="PaidParticipationOneOfThreeRequiredChecker ? 'required' : ''"
            :disabled="NoPaidParticipate"
            :data-vv-as="bp('findShopURL')"
            :label="bp('findShopURL')"
            :error="errors.first('tcrmPaidSearchFindLocalBikeShopUrl') ? bp('mustEnterURL') : ''"
            :show-error-messages="true"
            type="text"
            name="tcrmPaidSearchFindLocalBikeShopUrl"
            qaid="tcrm-edit-findShopURL"
          ></form-group>

          <form-group
            id="tcrmPaidSearchServiceAndRepairUrl"
            v-model="tcrmPaidSearchServiceAndRepairUrl"
            v-validate="PaidParticipationOneOfThreeRequiredChecker ? 'required' : ''"
            :disabled="NoPaidParticipate"
            :data-vv-as="bp('serviceURL')"
            :label="bp('serviceURL')"
            :error="errors.first('tcrmPaidSearchServiceAndRepairUrl') ? bp('mustEnterURL') : ''"
            :show-error-messages="true"
            type="text"
            name="tcrmPaidSearchServiceAndRepairUrl"
            qaid="tcrm-edit-serviceURL"
          ></form-group>

          <form-group
            id="tcrmPaidSearchBikeFittingUrl"
            v-model="tcrmPaidSearchBikeFittingUrl"
            v-validate="PaidParticipationOneOfThreeRequiredChecker ? 'required' : ''"
            :disabled="NoPaidParticipate"
            :data-vv-as="bp('bikeFittingURL')"
            :label="bp('bikeFittingURL')"
            :error="errors.first('tcrmPaidSearchBikeFittingUrl') ? bp('mustEnterURL') : ''"
            :show-error-messages="true"
            type="text"
            name="tcrmPaidSearchBikeFittingUrl"
            qaid="tcrm-edit-bikeFittingURL"
          ></form-group>
        </div>

        <hr class="rule mt-5" />

        <div class="buttons">
          <trek-button primary type="submit" qaid="tcrm-edit-submit">
            <span v-html="bp('save')"></span>
          </trek-button>
          <trek-link button secondary qaid="tcrm-edit-cancel" :href="cancelUrl">
            <span v-html="bp('cancel')"></span>
          </trek-link>
        </div>
      </form>
      <el-dialog
        :visible.sync="dialogVisible"
        :title="bp('paidSearchChange')"
        :center="true"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :z-index="16000011"
        qaid="tcrm-edit-modal"
        :close-dialog-tooltip="bp('closeDialogToolTip')"
        @close="closeDialog"
      >
        <template slot="footer">
          <div class="buttons buttons--center">
            <trek-button alert qaid="tcrm-edit-modal-yes" @click="confirmNoParticipation">
              <span v-html="bp('Y')"></span>
            </trek-button>
            <trek-button secondary qaid="tcrm-edit-modalno" @click="cancelNoParticipation">
              <span v-html="bp('N')"></span>
            </trek-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </main>
</template>

<script>
import get from 'lodash/get';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import ElDialog from '@/components/Dialog';
import FormGroup from '@/components/FormGroup';

export default {
  components: {ElDialog, FormGroup, TrekButton, TrekLink},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    tcrmData: {
      type: Object,
      default: () => {},
    },
    editUrl: {
      type: String,
      default: '',
    },
    cancelUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialogVisible: false,
      step: this.tcrmData.step,
      code: this.tcrmData.tcrm.code,
      tcrmPaidSearchBikeFittingUrl: this.tcrmData.tcrm.tcrmPaidSearchBikeFittingUrl || '',
      tcrmPaidSearchServiceAndRepairUrl: this.tcrmData.tcrm.tcrmPaidSearchServiceAndRepairUrl || '',
      tcrmPaidSearchFindLocalBikeShopUrl: this.tcrmData.tcrm.tcrmPaidSearchFindLocalBikeShopUrl || '',
      tcrmPaidSearchBudget: this.tcrmData.tcrm.tcrmPaidSearchBudget || '',
      tcrmThankYouEmail: '',
      tcrmBikeBirthdayEmail: '',
      tcrmSixMonthServiceReminderEmail: '',
      tcrmCatalogCoupons: '',
      tcrmPaidSearchParticipation: '',
      tcrmPaidSearchZipCodes: '',
      encodedContextPath: ACC.config.encodedContextPath,
    };
  },

  computed: {
    NoPaidParticipate() {
      return this.tcrmPaidSearchParticipation !== 'enumY';
    },

    // For bikeFittingURL, serviceURL, and findShopURL, only one of the three needs to be not empty
    PaidParticipationOneOfThreeRequiredChecker() {
      if (
        this.NoPaidParticipate ||
        this.tcrmPaidSearchBikeFittingUrl ||
        this.tcrmPaidSearchServiceAndRepairUrl ||
        this.tcrmPaidSearchFindLocalBikeShopUrl
      )
        return false;
      else return true;
    },

    tcrmThankYouEmailInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmThankYouEmail')
        .filter((item) => item.active === true)
        .map((item) => item.code);
      return filteredData.length ? filteredData[0] : '';
    },

    tcrmBikeBirthdayEmailInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmBikeBirthdayEmail')
        .filter((item) => item.active === true)
        .map((item) => item.code);
      return filteredData.length ? filteredData[0] : '';
    },

    tcrmSixMonthServiceReminderEmailInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmSixMonthServiceReminderEmail')
        .filter((item) => item.active === true)
        .map((item) => item.code);
      return filteredData.length ? filteredData[0] : '';
    },

    tcrmCatalogCouponsInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmCatalogCoupons')
        .filter((item) => item.active === true)
        .map((item) => item.code);
      return filteredData.length ? filteredData[0] : '';
    },
    tcrmPaidSearchParticipationInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmPaidSearchParticipation')
        .filter((item) => item.active === true)
        .map((item) => item.code);
      return filteredData.length ? filteredData[0] : '';
    },

    tcrmPaidSearchZipCodesInit() {
      let filteredData = get(this.tcrmData, 'tcrm.tcrmPaidSearchZipCodes');
      return filteredData
        ? filteredData.map((item, index) => (index === 0 ? item : `, ${item}`)).reduce((acc, item) => acc.concat(item))
        : '';
    },
  },

  created() {
    this.tcrmPaidSearchParticipation = this.tcrmPaidSearchParticipationInit;
    this.tcrmCatalogCoupons = this.tcrmCatalogCouponsInit;
    this.tcrmSixMonthServiceReminderEmail = this.tcrmSixMonthServiceReminderEmailInit;
    this.tcrmBikeBirthdayEmail = this.tcrmBikeBirthdayEmailInit;
    this.tcrmThankYouEmail = this.tcrmThankYouEmailInit;
    this.tcrmPaidSearchZipCodes = this.tcrmPaidSearchZipCodesInit;
  },

  mounted() {
    if (this.tcrmData.cancelTcrm === true) {
      this.$notify({
        type: 'warning',
        message: this.bp('changesNotSaved'),
      });
    } else if (this.tcrmData.savedSuccessfully === true) {
      this.$notify({
        type: 'success',
        message: this.bp('changesSaved'),
      });
    }
  },

  methods: {
    openDialog() {
      this.dialogVisible = true;
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    cancelNoParticipation() {
      this.closeDialog();
      this.tcrmPaidSearchParticipation = 'enumY';
    },

    confirmNoParticipation() {
      this.closeDialog();
      this.tcrmPaidSearchBudget = '';
      this.tcrmPaidSearchZipCodes = '';
      this.tcrmPaidSearchFindLocalBikeShopUrl = '';
      this.tcrmPaidSearchServiceAndRepairUrl = '';
      this.tcrmPaidSearchBikeFittingUrl = '';
    },

    enableEditStep() {
      this.step = 'write';
    },

    searchParticipationDialog() {
      if (
        // Only need to show the dialog if at least one of the optional fields is not empty
        this.NoPaidParticipate &&
        (this.tcrmPaidSearchBikeFittingUrl ||
          this.tcrmPaidSearchServiceAndRepairUrl ||
          this.tcrmPaidSearchFindLocalBikeShopUrl ||
          this.tcrmPaidSearchZipCodes ||
          this.tcrmPaidSearchBudget)
      ) {
        this.openDialog();
      }
    },

    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) this.$refs.TCRMDetailsForm.submit();
      });
    },
  },
};
</script>
